// extracted by mini-css-extract-plugin
export default {"wrapper":"BankTransfer_wrapper__c6+tR","description_wrapper":"BankTransfer_description_wrapper__QBB-F","transfer_description":"BankTransfer_transfer_description__ZFy1Y"};